module.exports = __webpack_public_path__ + "static/media/hoodie_child.f9a6018c.webp";